import React, { useCallback } from 'react';
import { captureButtonPress } from '../../../../features/analytics';
import { useTranslation } from 'react-i18next';
import { NewButton } from '../../../NewButton';

interface Props {
  tourID: string;
  buy: () => void;
}

export const TourWidgetNewBookNowButton: React.FC<Props> = ({
  tourID,
  buy,
}) => {
  const { t } = useTranslation();
  const page = window.location.pathname;

  const handleButtonClick = useCallback(() => {
    captureButtonPress({
      buttonName: 'BuyTour',
      tourID,
      page,
    });

    buy();
  }, [tourID, buy, page]);

  return (
    <NewButton
      highlight
      width="100%"
      minWidth="120px"
      onClick={handleButtonClick}
    >
      {t('Add to cart')}
    </NewButton>

    // <NewStyledButton onClick={handleButtonClick}>
    //   {t('Add to cart')}
    // </NewStyledButton>
  );
};
